// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PaperclipIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M26.207 15.293a1 1 0 0 1 0 1.415l-10.256 10.25a7.001 7.001 0 0 1-9.9-9.902L18.46 4.466a5.001 5.001 0 0 1 7.076 7.069l-12.41 12.59a3.005 3.005 0 0 1-4.25-4.25L19.288 9.298a1 1 0 1 1 1.424 1.402L10.3 21.289a1.001 1.001 0 0 0 1.409 1.42l12.408-12.584a3.002 3.002 0 1 0-4.241-4.25L7.47 18.46a5.002 5.002 0 0 0 7.066 7.078l10.258-10.25a1 1 0 0 1 1.413.005Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
